export default __webpack_public_path__ + "static/media/4b.562a1dd4.png";